
export const Colors = {
  primary: '#86409B',
  border: '#EDEFEF',
  purple: {
    main: '#86409B',
    c70: '#36235E',
    c60: '#52358E',
    c50: '#6E48BE',
    c40: '#9275CE',
    c30: '#B6A3DE',
    c20: '#DAD1EE',
    c10: '#F0EDF8'
  },
  orange: {
    main: '#F15A24',
    c70: '#7F511F',
    c60: '#BF7A2F',
    c40: '#FFBA6F',
    c30: '#FFD19F',
    c20: '#FFE7CF',
    c10: '#FFF5EC'
  },
  black: {
    main: '#000000',
    c50: '#232C2E',
    c40: '#5C6363',
    c30: '#8E9191',
    c20: '#C6C7C8',
    c10: '#EDEFEF'
  },
  green: {
    main: '#21C17C',
    c70: '#10603D',
    c60: '#18905C',
    c40: '#58D09C',
    c30: '#58D09C',
    c20: '#C7EFDE',
    c10: '#E9F8F2'
  },
  red: {
    main: '#D4145A',
    c70: '#70242A',
    c60: '#A9363F',
    c50: '#E24955',
    c40: '#E9767F',
    c30: '#F0A4AA',
    c20: '#F7D1D4',
    c10: '#FCEDEE'
  },
  blue: {
    main: '#379FDC',
    c70: '#1B4F6D',
    c60: '#2977A4',
    c40: '#69B7E4',
    c30: '#9BCFED',
    c20: '#CCE6F6',
    c10: '#EBF5FB'
  },
  white: {
    main: '#FFFFFF',
    c50: '#F5F7F8'
  },
  progress_orange: {
    main: '#F7931E',
    c20: '#FFE2C0'
  },
  gray: {
    main: '#8E9191',
    c20: '#EDEFEF'
  }
}
